import { Outlet } from "react-router-dom"
import { Sidebar } from "@/components/Sidebar/index"
import "./Dashboard.css"
import {useUser} from "@/utils/userContext/UserContext.tsx";
import { useEffect, useState } from "react";

type DashboardTheme = "light" | "dark";
const THEME_STORAGE_KEY = "cowonder-dashboard-theme";

const Dashboard = () => {
  const userContext = useUser();
  const userData = userContext?.userData;
  const [theme, setTheme] = useState<DashboardTheme>(() => {
    if (typeof window === "undefined") return "light";
    const saved = window.localStorage.getItem(THEME_STORAGE_KEY);
    return saved === "dark" ? "dark" : "light";
  });
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    document.documentElement.setAttribute("data-dashboard-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  if (!userData) {
    window.location.reload();
  }
  return (
    <div className={`dashboard-layout dashboard-theme-${theme} ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}>
      <Sidebar
        theme={theme}
        onToggleTheme={toggleTheme}
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed((prev) => !prev)}
      />
      <div className="dashboard-container">
        <Outlet />
      </div>
    </div>
  )
}

export default Dashboard
